import React from "react";
import { graphql } from "gatsby";
import Intro from "../components/Intro";
import PostList from "../components/PostList";
import SEO from "../components/SEO";
import Pagination from "../components/Pagination";
import Container from "../components/Container";
import { useSiteMetadata } from "../hooks/use-site-metadata";
import { startCase } from "lodash";

const TagPage = ({ data, pageContext }) => {
  const { image } = useSiteMetadata();

  let ogImage = image;
  const artworks = data.cms.artworks;

  return (
    <>
      <SEO
        title={`Tag: ${startCase(pageContext.tag)}`}
        description={`Artworks Tagged: ${startCase(pageContext.tag)}`}
        image={ogImage}
      />
      <Container fullWidth noPadding>
        <Intro
          text={`Tagged: ${pageContext.tag}`}
          context={pageContext}
          capitalize
        />
        {artworks.length > 0 && (
          <PostList artworks={artworks} context={pageContext} />
        )}
      </Container>
      <Pagination context={pageContext} />
    </>
  );
};

export default TagPage;

export const postsQuery = graphql`
  query($skip: Int!, $limit: Int!, $tag: [String!]) {
    cms {
      artworks(
        orderBy: createdAt_DESC
        skip: $skip
        first: $limit
        where: { tags_contains_some: $tag }
      ) {
        title
        createdAt
        content {
          markdown
        }
        description
        image {
          url
          cover: url(transformation: { image: { resize: { width: 300 } } })
        }
        tags
      }
    }
  }
`;
